import MicroModal from 'micromodal';

/**
 * Modal class to handle video and iframe autoplay.
 */
class Modal {
	constructor() {
		this.init();
	}

	init() {
		MicroModal.init({
			onShow: (modal?: HTMLElement | null) => {
				// Handle iframe autoplay
				this.handleIframeAutoplay(modal, true);

				// Handle video playback
				const video = modal?.querySelector('.modal__video') as HTMLVideoElement;
				if (video) {
					video.play().catch((error) => {
						console.error('Error playing video:', error);
					}); // モーダル表示時に動画を再生
				}
			},
			onClose: (modal?: HTMLElement | null) => {
				// Handle iframe autoplay
				this.handleIframeAutoplay(modal, false);

				// Handle video stop and reset
				const video = modal?.querySelector('.modal__video') as HTMLVideoElement;
				if (video) {
					video.pause(); // モーダル非表示時に動画を停止
					video.currentTime = 0; // 再生位置をリセット
				}
			},
			disableScroll: true,
		});
	}

	/**
	 * Handle iframe autoplay.
	 * @param modal    - The modal element
	 * @param autoplay - Whether to enable or disable autoplay
	 */
	handleIframeAutoplay(modal: HTMLElement | null, autoplay: boolean) {
		const iframe = modal?.querySelector('iframe');
		if (iframe) {
			const iframeSrc = iframe.getAttribute('src') || '';
			const url = new URL(iframeSrc, window.location.origin);
			url.searchParams.set('autoplay', autoplay ? '1' : '0');
			iframe.setAttribute('src', url.href);
		}
	}
}

// Run Modal.
new Modal();
